import React from 'react'

export default function EmptyOrderList() {
    return (
        <div className='d-flex justify-content-center align-items-center w-100 flex-column'>
            <img style={{ width: 270 }} src="https://static.vecteezy.com/system/resources/previews/047/468/658/non_2x/empty-state-empty-cart-illustration-free-vector.jpg" alt='empty order' />
            <h5>ບໍ່ພົບຂໍ້ມູນໃນຂະໜະນີ້!</h5>
        </div>
    )
}
